var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openModal
    ? _c(
        "div",
        [
          _c(
            "modal",
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass:
                        "md-simple md-just-icon md-round modal-default-button",
                      on: { click: _vm.closeSelectionModal },
                    },
                    [_c("md-icon", [_vm._v("clear")])],
                    1
                  ),
                  _c("md-table-toolbar", [
                    _c(
                      "div",
                      { staticClass: "filter-section" },
                      [
                        _c(
                          "md-field",
                          { staticStyle: { margin: "0px 40px" } },
                          [
                            _c("md-input", {
                              attrs: {
                                type: "search",
                                clearable: "",
                                placeholder: "Search Departments",
                              },
                              model: {
                                value: _vm.searchQuery,
                                callback: function ($$v) {
                                  _vm.searchQuery = $$v
                                },
                                expression: "searchQuery",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.checkSelectionLimit
                      ? _c(
                          "p",
                          { staticStyle: { color: "red", margin: "0px 40px" } },
                          [
                            _vm._v(
                              "Only the first 3 departments will be added to your profile"
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.checkSelectionMade
                      ? _c(
                          "p",
                          { staticStyle: { color: "red", margin: "0px 40px" } },
                          [_vm._v("Please select at least 3 departments")]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c("template", { slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "company-table" },
                  [
                    _c("md-table", {
                      attrs: { "md-card": "" },
                      on: { "md-selected": _vm.onSelect },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "md-table-row",
                            fn: function (ref) {
                              var item = ref.item
                              return _c(
                                "md-table-row",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { "md-selectable": "multiple" },
                                },
                                [
                                  _c(
                                    "md-table-cell",
                                    { attrs: { "md-label": "Departments" } },
                                    [_vm._v(_vm._s(item.department))]
                                  ),
                                ],
                                1
                              )
                            },
                          },
                        ],
                        null,
                        false,
                        460581786
                      ),
                      model: {
                        value: _vm.queriedData,
                        callback: function ($$v) {
                          _vm.queriedData = $$v
                        },
                        expression: "queriedData",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "filter-section" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success",
                        on: { click: _vm.confirmSelection },
                      },
                      [_vm._v(" Confirm")]
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger",
                        on: { click: _vm.cancelDepartmentSelection },
                      },
                      [_vm._v(" Cancel")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }